import React from 'react'
import PropTypes from 'prop-types'

import UserAvatar from 'Pods/Shared/UserAvatar/UserAvatar'
import Icon from 'Pods/Shared/Icon/Icon'

function ItemRating({ itemRating, isAdmin, removeItemRating }) {
  function removeRating(e) {
    e.preventDefault()

    removeItemRating(itemRating.id)
  }

  return (
    <li>
      <div className="project-comment__author">
        <a href={`/designers/${itemRating.author.username}`} className="author-link">
          <UserAvatar
            img={itemRating.author.avatarUrl}
            userName={itemRating.author.username}
            size="small"
            isWithName
          />
        </a>
        <div className="project-comment__date">
          {itemRating.createdAt}
        </div>
      </div>

      <div className="card card--flat">
        {itemRating.score === 1 ? (
          <div className="project-comment__rating"><Icon type="thumbs-up" color="green" /> Recommended</div>
        ) : (
          <div className="project-comment__rating"><Icon type="thumbs-down" color="red" /> Not Recommended</div>
        )}
        {itemRating.comment}

        {isAdmin && (
          <div className="project-comment__actions-bar">
            <a className="project-comment__action" onClick={(e) => removeRating(e)}>
              Delete
            </a>
          </div>
        )}
      </div>
    </li>
  )
}

ItemRating.propTypes = {
  itemRating: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  removeItemRating: PropTypes.func.isRequired,
}

export default ItemRating
